import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';
import {
  isLockedTour,
} from 'common/tourHelpers';

import branch from 'client/core/branch';

@withRouter
@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrTourRescheduleModal extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    userAgent: PropTypes.object.isRequired,
  };

  _onChooseAnotherTime = () => {
    const { tour, onClose, history } = this.props;
    const listing = tour.listings[0];

    isLockedTour({
      tour: tour,
      onUnlocked: () => {
        onClose();
        history.push(`/tour/${tour.id}/${listing.id}/choose-tour-time`);
      },
    });
  }

  _onCancelTour = () => {
    const { tour, onClose, history } = this.props;

    onClose();
    history.push(`/tour/${tour.id}/cancel`);
  };

  render() {
    const {
      onClose,
      userAgent,
    } = this.props;

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose}
          className={classnames(
            'darkModal',
            'darkNavigator',
            { webview: isMobileApp },
          )}
        >
          <div className='choiceContainer'>
            <div className='choiceGroup'>
              <div className='topLabel'>
                <span>Edit Tour</span>
              </div>
              <div className='choice' onClick={this._onChooseAnotherTime}>
                <span>Choose another time</span>
              </div>
              <div className='choice red' onClick={this._onCancelTour}>
                <span>Cancel tour</span>
              </div>
            </div>
            <div className='choice solo' onClick={onClose}>
              <span>Cancel</span>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

export default SrTourRescheduleModal;
